<template>
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <template v-if="loading">
      <div v-for="i in 3" :key="i" class="bg-white rounded-xl border border-gray-200 p-5 animate-pulse">
        <div class="h-4 bg-gray-200 rounded w-24 mb-4"></div>
        <div class="h-8 bg-gray-200 rounded w-32 mb-3"></div>
        <div class="h-5 bg-gray-200 rounded w-20"></div>
      </div>
    </template>
    <div v-else-if="error" class="col-span-full bg-red-50 border border-red-200 rounded-xl p-4 flex items-center justify-between">
      <span class="text-sm text-red-600">{{ error }}</span>
      <button @click="refresh" class="text-sm text-red-700 font-medium hover:underline">Reessayer</button>
    </div>
    <template v-else-if="data">
      <KpiCard
        v-for="kpi in kpis"
        :key="kpi.key"
        :label="kpi.label"
        :value="kpi.value"
        :evolution="kpi.evolution"
        :format="kpi.format"
        :icon="kpi.icon"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import KpiCard from './KpiCard.vue'

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/kpi/customers', dateParams)

const kpis = computed(() => {
  if (!data.value) return []
  const d = data.value
  return [
    { key: 'total_customers', label: 'Total clients', value: d.total_customers?.current, evolution: d.total_customers?.evolution, format: 'integer', icon: 'users' },
    { key: 'active_customers', label: 'Clients actifs', value: d.active_customers?.current, evolution: d.active_customers?.evolution, format: 'integer', icon: 'user-check' },
    { key: 'customer_revenue', label: 'CA clients', value: d.customer_revenue?.current, evolution: d.customer_revenue?.evolution, format: 'currency', icon: 'money-bill-wave' }
  ]
})
</script>
